/**
 * Products with no real options still carry a placeholder variant. Medusa
 * names it "Default variant"; some imports use plain "Default".
 */
const PLACEHOLDER_VARIANT_TITLES = new Set(["default variant", "default"]);

/**
 * The variant title to show, or `null` when there is nothing worth showing.
 *
 * A placeholder title names nothing the buyer chose, so printing it is noise
 * that reads as a real option. A genuine title ("250ml", "Blonde 9.0") is the
 * opposite: it is the only thing distinguishing one variant from another, so
 * it is always shown when present.
 *
 * Single owner for the rule across the whole app - variants surface in the
 * cart, the order summary, product cards and the product dialog, and those
 * disagreeing about the same product is exactly the drift this prevents.
 */
export function resolveVariantTitle(
  variantTitle?: string | null
): string | null {
  const trimmed = variantTitle?.trim();
  if (!trimmed) return null;
  return PLACEHOLDER_VARIANT_TITLES.has(trimmed.toLowerCase()) ? null : trimmed;
}
